/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmPopup } from "primereact/confirmpopup";
import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { InputSwitch } from "primereact/inputswitch";

export default function Boton({
  uri,
  callback,
  children,
  disabled,
  loader,
  confirmacion,
  tipo,
  texto,
  icono,
  chico,
  verde,
  azul,
  rojo,
  amarillo,
  negro,
  blanco,
  transparente,
  ancho,
  interruptor,
  interruptorActivo,
  menu,
  // Backward compat: parsear prop `clases` string mapeando a booleans
  clases: clasesString
}) {
  const [popupConfirmacion, setPopupConfirmacion] = useState(false);
  const boton = useRef(null);
  const navigate = useNavigate();

  // Backward compat: parsear clases string a booleans
  if (clasesString && typeof clasesString === "string") {
    const parts = clasesString.split(" ");
    if (parts.includes("verde")) verde = true;
    if (parts.includes("rojo")) rojo = true;
    if (parts.includes("amarillo")) amarillo = true;
    if (parts.includes("azul")) azul = true;
    if (parts.includes("negro")) negro = true;
    if (parts.includes("blanco")) blanco = true;
    if (parts.includes("texto")) texto = true;
    if (parts.includes("chico")) chico = true;
    if (parts.includes("relleno")) {
      // relleno = filled button (default PrimeReact behavior)
    }
    if (parts.includes("transparente")) transparente = true;
    if (parts.includes("centrado")) {
      // centrado handled by container
    }
  }

  let clases = "";
  if (chico) {
    clases = clases + " sinMargen";
  }
  if (negro) {
    clases = clases + " negro";
  }
  if (verde) {
    clases = clases + " verde";
  }
  if (azul) {
    clases = clases + " azul";
  }
  if (rojo) {
    clases = clases + " rojo";
  }
  if (amarillo) {
    clases = clases + " amarillo";
  }
  if (blanco) {
    clases = clases + " blanco";
  }
  if (ancho) {
    clases = clases + " ancho";
  }

  // Si es un boton de texto sin color especificado, aplicar azulCertx
  const esTextoSinColor =
    (texto || icono) && !verde && !azul && !rojo && !amarillo && !negro && !blanco;
  const estiloTextoAzul = esTextoSinColor
    ? { color: "var(--azulCertx)" }
    : {};

  // Si es un interruptor, renderizar InputSwitch
  if (interruptor) {
    return (
      <div
        css={{
          display: "flex",
          alignItems: "center",
          gap: "0.5em"
        }}
      >
        <InputSwitch
          checked={interruptorActivo}
          onChange={(e) => callback && callback(e.value)}
          disabled={disabled}
        />
        {children && <span>{children}</span>}
      </div>
    );
  }

  // Si tiene menu, renderizar SplitButton
  if (menu && menu.length > 0) {
    const menuItems = menu.map((item) => ({
      label: item.etiqueta,
      icon: item.icono,
      command: (e) => {
        const event = e.originalEvent;
        if (item.uri) {
          if (item.uri.startsWith("/")) {
            if (event.metaKey || event.ctrlKey) {
              window.open(item.uri, "_blank");
            } else {
              navigate(item.uri);
            }
          } else {
            window.open(
              item.uri,
              event.metaKey || event.ctrlKey ? "_blank" : "_self"
            );
          }
        } else if (item.callback) {
          item.callback(event);
        }
      }
    }));

    return (
      <>
        <SplitButton
          label={children}
          css={estiloTextoAzul}
          onClick={(event) => {
            if (confirmacion) {
              setPopupConfirmacion(true);
              return;
            }
            if (uri) {
              if (uri.startsWith("/")) {
                if (event.metaKey || event.ctrlKey) {
                  window.open(uri, "_blank");
                } else {
                  navigate(uri);
                }
              } else {
                window.open(
                  uri,
                  event.metaKey || event.ctrlKey ? "_blank" : "_self"
                );
              }
            } else if (callback) {
              callback(event);
            }
          }}
          ref={boton}
          model={menuItems}
          className={clases}
          size="small"
          loading={loader}
          outlined={transparente}
          disabled={disabled}
          text={texto}
        />

        <ConfirmPopup
          target={boton.current}
          visible={popupConfirmacion}
          onHide={() => setPopupConfirmacion(false)}
          message={confirmacion}
          icon="pi pi-exclamation-circle"
          accept={() => {
            if (uri) {
              if (uri.startsWith("/")) {
                navigate(uri);
              } else {
                window.location.href = uri;
              }
            } else if (callback) {
              callback();
            }
          }}
          rejectClassName="rojo transparente"
          rejectLabel="No"
          acceptClassName="verde transparente"
          acceptLabel="Si"
          acceptIcon="pi pi-check"
          rejectIcon="pi pi-times"
        />
      </>
    );
  }

  return (
    <>
      <Button
        label={children}
        css={estiloTextoAzul}
        onClick={(event) => {
          if (confirmacion) {
            setPopupConfirmacion(true);
            return;
          }
          if (uri) {
            if (uri.startsWith("/")) {
              if (event.metaKey || event.ctrlKey) {
                window.open(uri, "_blank");
              } else {
                navigate(uri);
              }
            } else {
              window.open(
                uri,
                event.metaKey || event.ctrlKey ? "_blank" : "_self"
              );
            }
          } else if (callback) {
            callback(event);
          }
        }}
        ref={boton}
        text={texto || icono}
        rounded={icono}
        className={clases}
        size="small"
        loading={loader}
        outlined={transparente}
        disabled={disabled}
        type={tipo}
      />

      <ConfirmPopup
        target={boton.current}
        visible={popupConfirmacion}
        onHide={() => setPopupConfirmacion(false)}
        message={confirmacion}
        icon="pi pi-exclamation-circle"
        accept={() => {
          if (uri) {
            if (uri.startsWith("/")) {
              navigate(uri);
            } else {
              window.location.href = uri;
            }
          } else if (callback) {
            callback();
          }
        }}
        rejectClassName="rojo transparente"
        rejectLabel="No"
        acceptClassName="verde transparente"
        acceptLabel="Si"
        acceptIcon="pi pi-check"
        rejectIcon="pi pi-times"
      />
    </>
  );
}
